import React, { useState, useEffect } from 'react';
import styles from './dashboard.module.scss';

import SideMenu from '../../components/SideMenu/sideMenu';
import GaragesPage from '../Garages/garagesPage';


const Dashboard = (props) =>
{
    const [garages, setGarages] = useState(true);

    return (
        <div className={styles.dashboard}>
            <SideMenu />
            <GaragesPage />
        </div>
    );
}

export default Dashboard;
